import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import 'styles/base/components/scroll-component/_scroll-component.scss';

export default class ScrollComponent extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node
  };

  render() {
    const { className, children } = this.props;
    return (
      <div
        className={className ? `scrollComponent ${className}` : 'scrollComponent'}
        children={children}
      />
    );
  }
}
